<template>
    <nav class="dark:bg-gray-800 w-80">
      <div class="sidebar-head px-4 mt-4">
        <router-link :to="{name: 'configuration'}" exact class="flex items-center gap-2 mt-6">
          <h2 class="text-lg text-gray-700 font-bold dark:text-gray-200" translate="no">
            Control<span class="text-primary-950"> Center</span>
          </h2>
        </router-link>
        <div class="bg-gray-700 absolute mt-3 dark:block hidden rounded-md py-1 px-2 text-xs text-gray-200">
          Dark mode
        </div>
        <button class="lg:hidden block dark:text-gray-400 float-right" @click="$emit('sidebarToggle')">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="25px" height="25px"
            preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32">
            <path fill="currentColor"
              d="M7.219 5.781L5.78 7.22L14.563 16L5.78 24.781l1.44 1.439L16 17.437l8.781 8.782l1.438-1.438L17.437 16l8.782-8.781L24.78 5.78L16 14.563z" />
          </svg>
        </button>
      </div>
      <div class="sidebar-list p-4 divide-y dark:divide-gray-700">
        <div v-for="menu in menus" :key="menu.name" class="pb-5">
          <p v-if="menu.groupByName" class="text-md text-gray-400 mt-2 dark:text-gray-400">{{ menu.name }}</p>
          <div v-for="option in menu.options" :key="option.route" class="item mt-2">
              <custom-menu-accordion v-if="option.collapsable" :collapsed="$route.meta.modules?.some(mod => mod == option.route)">
                <template v-slot:icon>
                  <Icon :icon="option.icon" />
                </template>
                <template v-slot:title>{{ option.name }}</template>
                <template v-slot:content>
                    <router-link 
                      v-for="(submenu, index) in option.childs"
                      :to="{name: submenu.route}"
                      :key="index"
                      class="w-full text-left block rounded-md p-3 hover:bg-gray-200 dark:hover:bg-gray-700 text-md"
                      :class="{'active': $route.name == submenu.route || $route.meta.modules?.some(mod => mod == submenu.route)}">
                      {{ submenu.name }}
                    </router-link>
                </template>
              </custom-menu-accordion>
  
              <router-link
                  v-else
                  :to="{name: option.route}" 
                  class="w-full flex text-left text-md rounded-md box-border p-3 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700"
                  :class="{'active': $route.name == option.route || $route.meta.modules?.some(mod => mod == option.route)}">
                <span class="mr-3 text-xl">
                  <Icon :icon="option.icon" />
                </span>
                <span class="w-full"> {{ option.name }}</span>
              </router-link>
          </div>
        </div>
      </div>
    </nav>
</template>
  
  <script setup>
  import { reactive, computed } from "vue";
  import { Icon } from "@iconify/vue";
  import CustomMenuAccordion from "./CustomMenuAccordion.vue";
//   import { useRoute } from 'vue-router'
  
//   const route = useRoute();
//   const { user, getRoles } = useAccount();
  
  const home = reactive(
  [
    {
      name: 'Home',
      route: 'configuration',
      icon: 'grommet-icons:home'
    },
    {
      name: 'Business',
      route: 'business',
      icon: 'ep:office-building',
      collapsable: true,
      childs: [{
        route: 'brandView',
        name: 'Branding'
      },
      // {
      //   route: 'login',
      //   name: 'Advanced'
      // },
      // {
      //   route: 'login',
      //   name: 'Audit Log'
      // }
      ],
      roles: []
    }
  ]);
  
  const administrations = reactive(
    [
    // {
    //     name: 'People',
    //     route: 'login',
    //     icon: 'charm:people',
    //     collapsable: true,
    //     childs: [
    //     {
    //       route: 'login',
    //       name: 'Roles'
    //     },
    //     {
    //       route: 'login',
    //       name: 'Groups'
    //     },
    //     {
    //       route: 'login',
    //       name: 'Members'
    //     },
    //     {
    //       route: 'login',
    //       name: 'Contacts'
    //     },
    //   ],
    //   roles: []
    // },
    {
      name: 'Channels',
      route: 'channels',
      icon: 'grommet-icons:connect',
      collapsable: true,
      childs: [{
        route: 'channelMessaging',
        name: 'Messaging'
      },
      {
        route: 'channelAIAgent',
        name: 'AI Agents'
      }],
      roles: []
    },
    {
      name: 'Rules',
      route: 'brandView',
      icon: 'lets-icons:setting-alt-line',
      collapsable: true,
      childs: [
      // {
      //   route: 'login',
      //   name: 'Fields'
      // },
      // {
      //   route: 'login',
      //   name: 'Routing'
      // },
      {
        route: 'brandView',
        name: 'Triggers'
      }],
      roles: []
    },
    {
      name: 'Integrations',
      route: 'brandView',
      icon: 'mingcute:code-line',
      collapsable: true,
      childs: [
      {
        route: 'brandView',
        name: 'Webhooks'
      }],
      roles: []
    },
  ]);
  
  const menus = computed(() => {
    // const roles = getRoles();
  
    const menuCategories = {
      General: {
        groupByName: false,
        options: home
      },
      Enterprise: {
        groupByName: true,
        options: administrations
      },
    };
  
    // const filteredMenus = Object.keys(menuCategories).map(categoryName => {
    //   return {
    //     name: categoryName,
    //     options: menuCategories[categoryName].filter(elemento => elemento.roles.some(rol => roles.includes(rol)))
    //   };
    // });
  
    // return filteredMenus.filter((menu) => {
    //   if(menu.options.length)
    //     return menu;
    // })

    const filteredMenus = Object.keys(menuCategories)
    .map(categoryName => {
      let currentCategory = menuCategories[categoryName];
      return {
        name: categoryName,
        groupByName: currentCategory.groupByName,
        options: currentCategory.options
      };
    });
  
    return filteredMenus.filter((menu) => {
      if(menu.options.length)
        return menu;
    })
  });
  </script>
  
<style lang="scss">
.active{
  @apply bg-primary-50;
}
</style>